import React from 'react';
import { LogoIcon } from './LogoIcon';
import { navLinks, cloudLink, privacyUrl, contactEmail } from '../data/siteLinks';
export function Footer() {
  return <footer className="relative bg-apple-light border-t border-gray-200 pt-14 pb-8 px-4 sm:px-6 lg:px-8" data-id="element-129" data-mp="3ghc0bvkn0rl2">
      <div className="max-w-7xl mx-auto" data-id="element-130" data-mp="32m1c310wf4po">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 mb-8" data-id="element-131" data-mp="36qhgexuv642s">
          <a href="#top" className="flex items-center gap-3 min-h-[44px] rounded-lg" data-id="element-132" data-mp="3uesclnpm7fkq">
            <LogoIcon size={32} data-id="element-133" data-mp="3991omvfnkca" />
            <span className="text-sm font-bold text-apple-black tracking-tight" data-id="element-134" data-mp="37fpks21w7ww">nexify-studio.tech</span>
          </a>
          <nav aria-label="Odkazy v pätičke" className="flex flex-wrap justify-center gap-x-6 text-sm text-apple-gray" data-id="element-135" data-mp="3le2kov3h69ca">
            {navLinks.map(link => <a key={link.href} href={link.href} className="inline-flex items-center min-h-[44px] hover:text-apple-black transition-colors duration-200" data-id="element-136" data-mp="29yxaz74xfaj6">
                {link.label}
              </a>)}
            <a href={cloudLink.href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center min-h-[44px] font-semibold text-apple-blue hover:text-apple-blueHover transition-colors duration-200" data-id="element-137" data-mp="3gapf5opniuim">
              {cloudLink.label}
              <span className="sr-only" data-id="element-138" data-mp="81yvkel2tq1v"> (otvorí sa v novom okne)</span>
            </a>
          </nav>
        </div>

        <div className="h-px bg-gray-200 mb-6" data-id="element-139" data-mp="335tdib8plh0" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-2 text-sm text-apple-gray" data-id="element-140" data-mp="hstrybs1e611">
          <p data-id="element-141" data-mp="ct75rcu8dfg3">© 2026 nexify-studio.tech. Všetky práva vyhradené.</p>
          <div className="flex flex-wrap justify-center gap-x-6" data-id="element-142" data-mp="cvtlw0v6t39x">
            <a href={`mailto:${contactEmail}`} className="inline-flex items-center min-h-[44px] hover:text-apple-black transition-colors duration-200" data-id="element-143" data-mp="qub97xh6kdrb">
              {contactEmail}
            </a>
            <a href={privacyUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center min-h-[44px] hover:text-apple-black transition-colors duration-200" data-id="element-144" data-mp="tta06hahyzxr">
              Ochrana súkromia
              <span className="sr-only" data-id="element-145" data-mp="18lbxpup3hgum"> (otvorí sa v novom okne)</span>
            </a>
          </div>
        </div>
      </div>
    </footer>;
}